<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.cid ? query.cid : query.pid}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>客户发票申请</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/apply' }">收款管理</el-breadcrumb-item>
        <el-breadcrumb-item>发票申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">新增发票</div>
        <el-form-item label="项目名称：">
          <el-col :span="12">
            {{ projectArr.contract_name ? projectArr.contract_name : form.projectArr.contract_name }}
          </el-col>
        </el-form-item>
        <el-form-item label="收款计划名称：">
          <el-col :span="12">
            {{ billArr.bill_name ? billArr.bill_name : form.billArr.bill_name }}
          </el-col>
        </el-form-item>
        <el-form-item label="开票金额：" prop="amount">
          <el-col :span="12">
            {{ billArr.amount ? billArr.amount : form.billArr.amount }}
          </el-col>
        </el-form-item>
        <el-form-item label="税率：" prop="tax_rate">
          <el-col :span="2">
            {{ form.tax_rate + '%' }}
          </el-col>
        </el-form-item>
        <el-form-item label="税额：" prop="tax">
          <el-col :span="2">
            {{ form.tax }}
          </el-col>
        </el-form-item>
        <el-form-item label="选择发票类型：" prop="type">
          <el-col :span="12">
            <el-select v-model="form.type" placeholder="请选择" style="margin-right: 0; width: 100%;">
              <el-option label="增值税普通发票" value="1"></el-option>
              <el-option label="增值税专用发票" value="2"></el-option>
              <el-option label="形式发票" value="3"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="期望开票时间：" prop="hope_time">
          <el-col :span="5">
            <el-date-picker v-model="form.hope_time" type="datetime" value-format="yyyy-MM-dd" style="width: 100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="开票内容：" prop="category">
          <el-col :span="12">
            <el-select v-model="form.category" placeholder="请选择" style="margin-right: 0; width: 100%;">
              <el-option label="设计服务费" value="1"></el-option>
              <el-option label="技术服务费" value="2"></el-option>
              <el-option label="咨询服务费" value="3"></el-option>
              <el-option label="会议服务费" value="5"></el-option>
              <el-option label="服务费" value="4"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="发票备注：" prop="invoice_mark">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="form.invoice_mark">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="form.info">
            </el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">申请</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <div class="base1">
      <h3 class="ntitle">开票信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ form.client_company }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.pay_bank }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p>
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.pay_bank_account)">{{ form.pay_bank_account
            }}</a>
          </p>
        </li>
      </ul>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'applydetail',
  data() {
    return {
      nodeLimtList: [],
      billList: [],
      projectArr: {},
      billArr: {
        bill_name: '',
        amount: '',
      },
      projectList: [],
      form: {
        //客户信息
        apply_id: '',
        apply_status: '0', //1是未申请，0已申请 
        project_id: '',
        project_bill_id: '',
        type: '2',
        amount: '',
        tax_rate: '',
        tax: '',
        hope_time: '',
        category: '1',
        invoice_mark: '',
        info: '',
        client_company: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        pay_bank: '',
        pay_bank_account: '',
        receive_date: '',
        option: '',
        projectArr: {
          contract_name: '',
        },
        billArr: {
          bill_name: '',
          amount: '',
        },
      },
      del_invoice_list: [],
      p: 1,
      type: 0,
      rules: {
        type: [
          {
            required: true,
            message: '请选择发票类型',
            trigger: 'change',
          },
        ],
        hope_time: [
          {
            required: true,
            message: '请输入期望开票时间',
            trigger: 'change',
          },
        ],
        category: [
          {
            required: true,
            message: '请输入开票内容',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    this.query.pid && (this.form.project_id = this.query.pid) && this.projectChange(this.query.pid)
    !this.query.id && this.checkUrlFn()
  },
  mounted() {

  },
  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 1);
      api.uploadFile(formData)
        .then((res) => {
          fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][0].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      console.log(arr);
      arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
      this.$forceUpdate()
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
      this.$forceUpdate()
    },
    projectChange(v) {
      this.form.project_bill_id = ''
      this.billList = []
      this.toReceive = ''
      this.form.tax_rate = ''
      if (v) {
        this.$fly
          .post('apiProject_getDetail.html', { project_id: v })
          .then((res) => {
            this.billList = res.billList
            this.projectArr = res.itemArr
            this.query.bid && (this.form.project_bill_id = this.query.bid) && this.billChange(this.query.bid)//带参数
          })
      }
    },
    billChange(v) {
      this.toReceive = ''
      this.form.tax = ''
      const {
        client_company,
        company_id_card,
        reg_address,
        company_phone,
        pay_bank,
        pay_bank_account,
        tax,
        tax_rate,
      } = this.projectArr
      this.form = {
        ...this.form,
        client_company,
        company_id_card,
        reg_address,
        company_phone,
        pay_bank,
        pay_bank_account,
        tax,
        tax_rate,
      }
      this.billList.forEach(item => {
        if (item.id == v) {
          this.billArr = item
          this.form.amount = item.amount
        }
      })
      if (this.billArr.amount) {//如果先填了金额，自动修改税额
        this.amountChange()
      }
    },
    amountChange() {
      const taxRate = Number(this.projectArr.tax_rate);
      this.form.tax = (this.billArr.amount) > 0 ? (this.billArr.amount / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2) : 0
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiSale_getInvoiceApplyDetail.html', {
          apply_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          //修改0000-00-00错误显示1899年情况
          form.hope_time = form.hope_time == '0000-00-00' ? '' : form.hope_time
          //每次进入重新计算税额，以防发票作废
          const taxRate = Number(form.tax_rate);
          form.tax = Number(form.amount) > 0 ? (Number(form.amount) / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2) : 0
          return (this.form = form)
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateInvoiceApply()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateInvoiceApply() {
      this.form.apply_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.projectArr
      delete tempForm.billArr
      delete tempForm.receiveList
      delete tempForm.invoiceList
      delete tempForm.applyLogList
      delete tempForm.apply_status //删除申请状态
      this.$fly
        .post('apiSale_addUpdateInvoiceApply.html', {
          ...tempForm,
          isInvoice: '1',
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
    .anlist {
      padding: 0;

      li {
        position: relative;

        .abox {
          .abox-title {
            font-size: 13px;
            line-height: 32px;
            margin-bottom: 30px;
          }
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }      
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }
}
</style>
